"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var atlanticTheme_1 = require("./atlanticTheme");
var chameleonTheme_1 = require("./chameleonTheme");
var gowizardTheme_1 = require("./gowizardTheme");
var indigoTheme_1 = require("./indigoTheme");
var rhubarbTheme_1 = require("./rhubarbTheme");
var auroraTheme_1 = require("./auroraTheme");
var apricotTheme_1 = require("./apricotTheme");
var themeCreator_1 = require("./themeCreator");
var palettes = {
    atlantic: atlanticTheme_1.atlanticPalette,
    chameleon: chameleonTheme_1.chameleonPalette,
    gowizard: gowizardTheme_1.gowizardPalette,
    indigo: indigoTheme_1.indigoPalette,
    rhubarb: rhubarbTheme_1.rhubarbPalette,
    aurora: auroraTheme_1.auroraPalette,
    apricot: apricotTheme_1.apricotPalette,
    custom: themeCreator_1.customPalette,
};
exports.default = palettes;
//# sourceMappingURL=palettes.js.map